import './polyfils/forEach';
import 'video.js';
//import 'videojs-youtube';

import './components/main-page/event-slider';
import eventSlider from './components/main-page/event-slider';
import Header from "./components/header";
import HeaderNew from "./components/header-new";
import CustomerWins from './components/main-page/customer-wins';
import contactUsBtn from './components/contact-us-btn';
import language from "./components/language";
import customVideo from './components/custom-video';
import CustomSearch from './components/custom-search';
import customVideoModal from './components/custom-video-modal';
import testimonialsSlider from './components/testimonials-slider';
import partnersTabs from "./components/partners-tabs";
import cleanSlider from "./components/clean-slider";
import teachersSlider from "./components/teachers-slider";
import cleanSliderMobile from "./components/clean-slider-mobile";
import editorSlider from "./components/editor-slider";
import columns2 from "./components/columns2";
import accordion from "./components/accordion";
import tabsi from "./components/tabsi";
import faq from "./components/faq";
import './components/insights/analyst-reports-slider';
import eventConstructor from "./components/event-constructor";
import mapTelecom from "./components/map-telecom";
import leftMenuScroll from "./components/left-menu-scroll";

import $ from "jquery";
import management from "./components/management";
import productNew from "./components/product-new";

window.$ = $;

if (document.querySelector(".customer-wins")) {
  CustomerWins();
}
if (document.querySelector('.contact-us-btn')) {
  contactUsBtn();
}

$('.custom-video').each((key, videoElement) => {
  customVideo(videoElement);
});

if (document.querySelector('.events-slider__container')) {
  eventSlider();
}
if (document.querySelector('.header')) {
  Header();
  new HeaderNew();
}
if (document.querySelector('.language')) {
  language();
}
if (document.querySelector('.header__search')) {
  CustomSearch();
}
if(document.querySelector('.testimonials-slider')) {
  testimonialsSlider()
}
if(document.querySelector('.partners-tabs')) {
  partnersTabs()
}
if(document.querySelector('.management')) {
  management()
}
if(document.querySelector('.clean-slider')) {
    cleanSlider()
}
if(document.querySelector('.teachers-slider')) {
    teachersSlider()
}
if(document.querySelector('.clean-slider-mobile')) {
    cleanSliderMobile()
}
if(document.querySelector('.product-new-header')) {
    productNew()
}
customVideoModal();
editorSlider();
columns2();
accordion();
eventConstructor();
tabsi();
faq();
mapTelecom();
leftMenuScroll();

$(window).resize(function () {
    columns2();
});

$(window).scroll(function () {
    scrollFunction()
});
scrollFunction();

$('.emulate-link').click(function (e) {
   e.preventDefault();
   if($(this).attr('href')) {
     if($(this).attr('target') === '_blank') {
       window.open($(this).attr('href'));
     } else {
       location.href = $(this).attr('href');
     }
   }
});

$('.editor-content p').each(function () {
    if($(this).text() === ' '){
      $(this).addClass('p-space');
    }
});

$('.page-up-block').click(function(){
    $('html, body').animate({scrollTop: 0}, '300');
});

function scrollFunction() {
    if ($(window).scrollTop() > 1000) {
        if ($('.page-up-wrapper').hasClass('hide')) {
            $('.page-up-wrapper').toggleClass('hide')
        }
    } else {
        if (!$('.page-up-wrapper').hasClass('hide')) {
            $('.page-up-wrapper').toggleClass('hide')
        }
    }
}

$('.get-in-touch__button,.get-in-touch__button_nostyle').click(function () {
    $('.get-in-touch__overlay,.get-in-touch__popup').css('display','block');
    $("html").addClass("noscroll-768")
});

$(".get-in-touch__overlay,.get-in-touch__popup-close").click(function () {
    $('.get-in-touch__overlay,.get-in-touch__popup').css('display','none');
    $("html").removeClass("noscroll-768")
});

$('.js_modal').click(function (){
    if(
        $(this).attr('data-substrate') !== undefined &&
        $($(this).attr('data-substrate')).length &&
        $(this).attr('data-modal') !== undefined &&
        $($(this).attr('data-modal')).length
    ) {
        let substrate = $($(this).attr('data-substrate'));
        let modal = $($(this).attr('data-modal'));

        substrate.fadeIn(500);
        modal.fadeIn(500);

        substrate.click(function () {
            substrate.fadeOut(500);
            modal.fadeOut(500);
        });

        modal.find('.modal_form_close').click(function () {
            substrate.fadeOut(500);
            modal.fadeOut(500);
        });
    }
});
